<template>
  <div class="a">
    <Nav/>
    <PageBannerBig :banner="banner"></PageBannerBig>
    <div class="service-content">
      <div class="content">
        <div class="title-name">IT基础设施解决方案</div>
        <div class="title-sub">概述</div>
        <div class="text">
          随着智慧业务的快速发展，越来越多的客户在考虑建设和优化IT基础设施以更好支撑上层智慧业务。<br>
          IT基础设施需要满足上层智慧业务对数据的采集、通讯、转换、和整理以及应用和共享的需求。通过在架构上的设计优化，为智慧业务提供定制化的方案，充分照顾到项目整个生命周期的诉求以实现业务快速落地和稳定运行和长期高效运维的目的，并建立综合平台实现硬件资源弹性调度和数据交换、分享。<br>
          本方案为智慧业务应用提供了多层次的IT基础设施平台，提供上层应用运行所需的IT资源，为智慧业务的进一步发展打下良好基础。
          <div class="img"><img src="@/assets/img/solution/13/1.png"></div>
        </div>
        <div class="title-sub">解决方案</div>
        <div class="text">
          云融合的数据中心IT基础设施方案<br>
          1. 智慧业务一体机提供集成式预部署方案，将少量智慧业务集成到1-4个预部署和IT整体交付机柜中，降低项目实施整体复杂度，推动业务迅速上线和后续平稳运行。<br>
          2. 私有云架构数据中心为复杂和大规模的智慧业务量身定制：通过集成顶级合作伙伴的硬件和软通为主的云平台，打造从机房建设到应用交付的整个垂直体系，整体交付；也可通过集成满足等保3级的合作伙伴政务云平台，将智慧业务落地于云服务平台上，实现敏捷交付和用户方的轻资产运营。<br>
          3．混合云架构数据中心融合了私有数据中心安全性、可控性和公有数据中心几乎无限弹性扩展的特点，为具有弹性业务需求的智慧业务提供了一种集成解决方案。
          <div class="img"><img src="@/assets/img/solution/13/2.png"></div>
          端到端的智慧业务基础设施方案<br>
          将智慧业务的支持延伸至园区、城域和广域。考虑IoT感知末端延伸部署设计和分层设计，以及安全架构；配合工业物联网方案和各项智慧业务如环保、交通，提供为物联网流量和架构优化的端到端基础设施，并利用IT基础设施补充地理位置、时间、末端设备属性、人员属性等信息，为上层业务提供智能、安全的基础架构。利用云平台/SDN，实现跨城市间的智能资源调度，实现集中管控。
          <div class="img"><img src="@/assets/img/solution/13/3.png"></div>
        </div>
        <div class="title-sub">能力优势</div>
        <div class="text">
          全智慧业务支撑方案
          多组合方案满足了支撑客户多种类智慧业务的建设需求。<br>
          云融合能力<br>
          利用不同的云平台，根据实际业务需求和安全级别，将私有云和公有云融合，满足不同应用差异化安全需求，实现业务弹性扩展。<br>
          橡诺科技是华为企业云战略合作伙伴<br>
          智慧的基础设施<br>
          将基础设施覆盖到城域和广域，基础设施协助补充基于各种场景的大数据元素，更好的支撑业务智慧决策。<br>
          预集成、预交付能力<br>
          以智慧业务一体机为主，预分析了智慧业务的典型场景需求，快速设计和整体交付客户所需要的数据中心基础设施。<br>
          端到端系统集成能力<br>
          提供数据中心底层机房、城域IT基础到上层应用的整体优化集成<br>
          提供共享、开放平台的能力<br>
          打破各应用系统间的信息壁垒，建立信息共享、互连、开放的平台。
        </div>
        <div class="title-sub">客户收益</div>
        <div class="text">
          通过系统建设，客户能够实现如下的业务需求：<br>
          快速业务落地：利用云平台实现IT敏捷性，预集成、预部署来缩短IT交付时间，端到端方案简化了项目管理复杂度，从而实现快速业务落地<br>
          实现全方位IT基础设施演进：集成设计面向IoT、具备多感知能力的城域网、流量智能导控的广域网以及多种云架构和大数据技术的数据中心，为现在和未来的各种智慧业务提供强有力支撑<br>
          兼容性和贴切设计：基于全局整体考虑的设计，满足不同层次间的容量匹配和特征兼容<br>
          安全可靠兼顾性价比：利用不同的云计算资源和底层平台，来满足不同客户的不同安全需求，同时满足性价比需求。<br>
          实现集中管控、共享交换：利用云计算平台和上层统一大数据平台，实现数据共享交换和数据中心IT资源池化，实现集中动态调度和管控，实现资源的最佳利用。
        </div>
        <div class="title-sub">典型客户</div>
        <div class="text">
          智慧城市客户群，用于支撑政务大数据等为主的业务平台<br>
          智慧产业客户群，建设产业客户的底层IT平台，支撑产业发展
        </div>
      </div>
      <Mission/>
    </div>

    <Contact/>
    <Footer/>
  </div>
</template>

<script>
import Nav from '@/components/Nav'
import PageBannerBig from '@/components/PageBannerBig'
import Contact from '@/components/Contact'
import Footer from '@/components/Footer'
export default {
  name: '',
  components: {
    Nav,
    PageBannerBig,
    Contact,
    Footer
  },
  data () {
    return {
      banner: {
        img: require("@/assets/img/solution-banner.jpg"),
        title: "为您提供专业的解决方案",
        sub: "专业的服务 高效的方案"
      }
    }
  }
}
</script>

<style scoped lang="less">
.service-content{
    width: 100%;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    background-image: url(../../assets/img/service-bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .content{
      width: 1200px;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      .title-name{
        height: 38px;
        color: #333333;
        transform: .5s;
        line-height: 38px;
        font-size: 30px;
        margin-top: 80px;
        margin-bottom: 38px;
        text-align: center;
        box-sizing: border-box;
      }
      .title-sub{
        color: #333;
        line-height: 24px;
        font-size: 20px;
        text-align: left;
        box-sizing: border-box;
        width: 200px;
        margin-top: 30px;
        margin-bottom: 10px;
        border-radius: 30px;
      }
      .text{
        color: #666;
        line-height: 24px;
        font-size: 14px;
        box-sizing: border-box;
        .img{
          padding: 30px;
          margin: 20px auto;
          background: #fff;
          text-align: center;
        }
      }
    }
}
</style>